import { Language } from '@/types/language';

export type Outlet = 'iitv' | 'aitv';
export type Locale = 'fa' | 'en' | 'ar' | 'pa';

export type LanguageDetails = {
  shortCode: Locale;
  locale: string;
};

export { Language } from '@/types/language';

export type OutletLanguageConfig = Partial<Record<Language, LanguageDetails>>;